@if (HasRequiredPermissions) {
  @if (hasWebSocketChanges()) {
    <div class="absolute top-[3.2em] right-[1.5em] px-3 py-0 bg-yellow-50 border border-yellow-500 rounded-lg flex items-center justify-between z-50">
      <span class="text-xs text-yellow-800">
        {{ 'Record ' | translate }} {{ 'modified' | translate }}.
        ({{ totalModifiedCount() }} {{ 'changes' | translate }})
      </span>
    </div>
  }
  @if (EntityInstance || isNew()) {
    <!-- Conteneur principal avec layout flexbox -->
    <div [fieldContext]="this" class="flex flex-col h-full">
      <!-- Titre fixe en dehors de la zone de défilement -->
      <div class="px-6 pt-4 pb-2">
        <h4 class="text-[0.9em] font-medium text-gray-500 z-[999]">
          @if (isNew()) {
            {{ 'entities.trucker.newEntity' | translate }}
          } @else {
            {{ 'entities.trucker.detailEntity' | translate }}
          }
        </h4>
        <div class="flex justify-between items-center">
          <button (click)="cancelEdit()" data-testid="detail-close" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      <!-- Zone de contenu avec défilement -->
      <div #scrollContainer class="{{Skin.detailContainer}} flex-1 overflow-auto">
        <!--  Conteneur desactivable -->
        <div class="{{this.UpdateMode}}">
          <div class="">
            <h3 class="{{Skin.formSectionSmallTitle}}">
              <i class="fa-solid fa-user"></i> {{
              'vues.trucker.detail.sections.trucker-info' | translate
              }}
            </h3>
            <div class="space-y-2">
              <!-- Champ selectedPK_Pos (multi-select) -->
              <app-field-wrapper property="selectedPK_Pos" businessProperty="fK_POS" label="entities.account.propreties.pos">
                <app-multi-select #multiSelect
                  [options]="pointOfServiceLookup()"
                  [placeholder]="'Select Sites'"
                  [maxItems]="1"
                  [isMultiselect]="false"
                  onReady
                  (autoBind)="bindingHandler($event, 'selectedPK_Pos', multiSelect)"
                  [selectedKeys]="editingEntity()?.selectedPK_Pos ?? []"
                  (selectedKeysChange)="onPOSselectChange($event)">
                </app-multi-select>
              </app-field-wrapper>
              <!-- Champ firstName -->
              <app-field-wrapper property="firstName">
                <input type="text" autocomplete="off" onReady

                  class="{{Skin.formInputSmallSize}}"
                  (autoBind)="bindingHandler($event, 'firstName')">
                </app-field-wrapper>
                <!-- Champ lastName -->
                <app-field-wrapper property="lastName">
                  <input type="text" autocomplete="off" onReady

                    class="{{Skin.formInputSmallSize}}"
                    (autoBind)="bindingHandler($event, 'lastName')">
                  </app-field-wrapper>
                  <!-- Champ companyName -->
                  <app-field-wrapper property="companyName">
                    <input type="text" autocomplete="off" onReady

                      class="{{Skin.formInputSmallSize}}"
                      (autoBind)="bindingHandler($event, 'companyName')">
                    </app-field-wrapper>
                    <!-- Champ address (textarea) -->
                    <app-field-wrapper property="address">
                      <textarea autocomplete="off" onReady

                        class="{{Skin.formInputSmallSize}}"
                      (autoBind)="bindingHandler($event, 'address')"></textarea>
                    </app-field-wrapper>
                    <!-- Champ email -->
                    <app-field-wrapper property="email">
                      <input type="email" autocomplete="off" onReady

                        class="{{Skin.formInputSmallSize}}"
                        (autoBind)="bindingHandler($event, 'email')">
                      </app-field-wrapper>
                      <!-- Champ phoneNumber -->
                      <app-field-wrapper property="phoneNumber">
                        <input type="tel" autocomplete="off" onReady

                          class="{{Skin.formInputSmallSize}}"
                          (autoBind)="bindingHandler($event, 'phoneNumber')">
                        </app-field-wrapper>
                        <!-- Champ fK_Language (select) -->
                        <app-field-wrapper property="fK_Language" label="entities.trucker.propreties.language">
                          <select class="{{Skin.formInputSmallSize}}" required onReady
                            (autoBind)="bindingHandler($event, 'fK_Language')"
                            [class.border-red-500]="hasValidationErrors('fK_Language')">
                            <option [value]="null" disabled>{{ 'Choose a language' | translate }}</option> <!-- Placeholder -->
                            @for (languageOption of languageLookup(); track languageOption.key) {
                              <option [value]="languageOption.key">{{ `languages.${languageOption.value}` | translate }}</option>
                            }
                          </select>
                        </app-field-wrapper>
                        <!-- Champ status (reactive-badge) -->
                        <app-field-wrapper property="status">
                          <app-reactive-badge [status]="$safeNavigationMigration(editingEntity()?.status)"
                            [lookupData]="truckerStatusLookup()"
                            [Skin]="Skin"
                            [isEditMode]="true"
                            (statusChange)="onStatusChange($event)">
                          </app-reactive-badge>
                        </app-field-wrapper>
                        <!-- Champ comment (textarea) -->
                        <app-field-wrapper property="comment">
                          <textarea autocomplete="off" onReady

                            class="{{Skin.formInputSmallSize}}"
                          (autoBind)="bindingHandler($event, 'comment')"></textarea>
                        </app-field-wrapper>
                        <!-- Champ licence -->
                        <app-field-wrapper property="licence">
                          <input type="text" autocomplete="off" onReady

                            class="{{Skin.formInputSmallSize}}"
                            (autoBind)="bindingHandler($event, 'licence')">
                          </app-field-wrapper>
                          <!-- Champ validated (reactive-badge) -->
                          <app-field-wrapper property="validated">
                            <app-reactive-badge [status]="$safeNavigationMigration(editingEntity()?.validated)"
                              [lookupData]="truckerValidationStateLookup()"
                              [Skin]="Skin"
                              [isEditMode]="true"
                              (statusChange)="onValidatedChange($event)">
                            </app-reactive-badge>
                          </app-field-wrapper>
                        </div>
                      </div>
                      <div class="mt-10">
                        <h3 class="{{Skin.formSectionSmallTitle}}">
                          <i class="far fa-envelope"></i> {{
                          'vues.trucker.detail.sections.notifications' | translate
                          }}
                        </h3>
                        <div class="space-y-2">
                          <!-- Champ emailNotification (checkbox) -->
                          <app-field-wrapper property="emailNotification">
                            <input class="w-5 h-5 mr-2 cursor-pointer" type="checkbox" onReady

                              (autoBind)="bindingHandler($event, 'emailNotification')">
                            </app-field-wrapper>
                            <!-- Champ smsNotification (checkbox) -->
                            <app-field-wrapper property="smsNotification">
                              <input class="w-5 h-5 mr-2 cursor-pointer" type="checkbox" onReady

                                (autoBind)="bindingHandler($event, 'smsNotification')">
                              </app-field-wrapper>
                            </div>
                          </div>
                          <div class="mt-10 ">
                            <h3 class="{{Skin.formSectionSmallTitle}}">
                              <div style="display: flex; align-items: center;">
                                <span class="fa-stack" style="font-size: 1em; margin-left: -10px;">
                                  <i class="fas fa-file fa-stack-1x" style="color: #ccc;"></i>
                                  <i class="fas fa-file fa-stack-1x" style="color: #999; position: absolute; top: 4px; left: 4px;"></i>
                                  <i class="fas fa-file fa-stack-1x" style="color: #666; position: absolute; top: 8px; left: 8px;"></i>
                                </span>
                                <span class="{{Skin.formSectionSmallTitleSpan}}" style="margin-top: 8px;">
                                  {{
                                  'vues.trucker.detail.sections.attachments.title' | translate
                                  }}
                                </span>
                              </div>
                            </h3>
                            <div class="space-y-2">
                              <div class="relative">
                                <a class="cursor-pointer " (click)="sendAgreements()">
                                  <i class="fa-solid fa-share" style="color: #FF586B;"></i>
                                  <span class="ml-2 text-[0.68em] text-gray-500 tracking-wide uppercase font-medium">
                                    {{
                                    'vues.trucker.detail.sections.attachments.sendAgreements' | translate
                                    }}
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Bandeau pour le nombre d'erreurs -->
                      @if (generalErrorCount() > 0) {
                        <div class="mb-1 p-1 bg-orange-100 text-red-700 border border-orange-300 rounded-full text-xs sticky bottom-14 z-10 py-1 -mt-1 z-20 text-center">
                          <i class="fas fa-exclamation-triangle mr-1 ml-2"></i>
                          {{ generalErrorCount() }} erreur(s) dans le formulaire
                        </div>
                      }
                      <!-- Boutons en bas du formulaire -->
                      <div class="bg-stone-50 min-w-full flex space-x-1 justify-center pt-2 border-t border-gray-200">
                        @if (HasEditPermission) {
                          <button name="SaveButton" data-testid="detail-save"
                            type="button"
                            (click)="saveItem()" [disabled]="!isFormValid()"
                            class="{{Skin.btnPrimary}} uppercase py-2 px-2">
                            <i class="far fa-check-square mr-2"></i>
                            {{ 'buttons.save' | translate }}
                          </button>
                        }
                        @if (HasEditPermission) {
                          <button name="SaveAndCloseButton" data-testid="detail-save-close"
                            type="button" (click)="saveAndCloseItem()" [disabled]="!isFormValid()"
                            class="{{Skin.btnPrimary}} uppercase py-2 px-2">
                            <i class="far fa-check-square mr-2"></i>
                            {{ 'buttons.save-and-close' | translate }}
                          </button>
                        }
                        <button (click)="cancelEdit()" data-testid="detail-cancel" class="{{Skin.btnAlert}} uppercase py-2 px-2">
                          <i class="fas fa-times mr-2"></i>
                          {{ 'buttons.cancel' | translate }}
                        </button>
                      </div>
                    </div>
                  }
                }